import React from 'react';
import i18n from '../../../../../i18n';
import type { DrillPosDeadHours } from '../../../types';
import { DrillTile } from './DrillTile';
import { countLabel, hourLabel, weekdayLabel } from './substanceFormat';

const T = 'performance:drillPos.dead';

/** "Tue 14:00–17:00" for one run of dead hours. */
export function deadHourLabel(row: DrillPosDeadHours['rows'][number]): string {
  return i18n.t(`${T}.row`, {
    day: weekdayLabel(row.weekday),
    from: hourLabel(row.startHour),
    to: hourLabel(row.endHour),
  });
}

export function DrillDeadHoursSection({
  data,
}: {
  metricKey: string;
  data: DrillPosDeadHours;
}) {
  return (
    <DrillTile
      sectionId="pos-dead-hours"
      span={4}
      title={i18n.t(`${T}.title`)}
      meta={countLabel(`${T}.checked`, data.checkedHours)}
    >
      {data.rows.length ? (
        <>
          <ul className="dsub-list">
            {data.rows.map(r => (
              <li
                className="dsub-list-row"
                key={`${r.restaurantId}-${r.weekday}-${r.startHour}`}
              >
                <span>
                  <strong>{deadHourLabel(r)}</strong>
                  {data.multiOutlet && r.outlet ? (
                    <span className="dsub-n"> · {r.outlet}</span>
                  ) : null}
                </span>
                <span className="dsub-n">{countLabel(`${T}.zeroOver`, r.days)}</span>
              </li>
            ))}
          </ul>
          {data.more > 0 ? (
            <p className="dsub-n">{i18n.t(`${T}.more`, { count: data.more })}</p>
          ) : null}
          <p className="ddrill-tile-note">
            <strong>{countLabel(`${T}.perWeek`, data.deadHours)}</strong>
          </p>
        </>
      ) : (
        <p className="ddrill-tile-note">{i18n.t(`${T}.none`)}</p>
      )}
      <p className="ddrill-tile-note">{i18n.t(`${T}.basis`)}</p>
    </DrillTile>
  );
}
